import { request } from "../request";

/**
 * 获取语言列表
 * @returns 
 */
export function GetLanguageList() {
    return request<DB.Language[]>({
        url: '/Language/GetLanguageList',
        method: 'get'
    })
}